import { ISourceDataForm } from "@/api/dtos";
import { useScopedField } from "@ngt/forms-core";
import { useMemo } from "react";

const useSourceDataSectionReviewCount = (propertyPath: string, fieldKeys: string[], repeat: number) => {
    const { state: { value }} = useScopedField<ISourceDataForm>(propertyPath, { value: true }, false, true);

    const counts = useMemo(() => {
        if (!value) {
            return undefined;
        }

        let total = 0;
        let reviewed = 0;
        let verified = 0;
        let totalToReview = 0;
        let totalToVerify = 0;

        if (fieldKeys && value.fields) {
            for (let key of fieldKeys) {
                total++;

                if (value.fields[key]?.[repeat]?.reviewed) {
                    reviewed++;
                }

                if (value.fields[key]?.[repeat]?.verified) {
                    reviewed++;
                }
            }
        }

        if (total > 0) {
            return {
                reviewed,
                verified,
                totalToReview,
                totalToVerify,
                total
            };
        }

        return undefined;
    }, [value, fieldKeys, repeat])

    return counts;
}

export default useSourceDataSectionReviewCount;